import React, { type PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import ErrorPage from '@sputnik/components/ErrorPage'
import { logError } from '@sputnik/utils/loggerUtils'

const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
  logError(error, {
    attributes: {
      stackTrace: errorInfo?.componentStack,
    },
    eventName: 'PageErrorBoundary',
    message: error?.toString(),
  })
}

const PageErrorBoundary = ({ children }: PropsWithChildren) => (
  <ErrorBoundary
    FallbackComponent={ErrorPage}
    onError={handleError}
  >
    {children}
  </ErrorBoundary>
)

export default PageErrorBoundary
